<template>
    <vue-final-modal
        @opened="opened"
        v-bind="$attrs"
        v-slot="{ close }"
        :esc-to-close="true"
    >
        <div class="opui-modal opui-modal-course-edit">
            <div class="opui-modal-dialog opui-mw-900">
                <div class="opui-modal-content">
                    <div class="opui-modal-header">
                        <h1 v-if="item.type === 'delay'">{{ $e('Delay') }}</h1>
                        <h1 v-else-if="item.type === 'filter'">{{ $e('Filter') }}</h1>
                        <h1 v-else>{{ $e('Workflow Action') }}</h1>
                        <i @click.prevent="close" class="opui-icon-close opui-modal-close"></i>
                    </div>

                    <div class="opui-modal-body">
                        <form class="opui-form" @submit.prevent="save" method="post">
                            <ItemType   :workflow="workflow" :item="item" v-if="! item.type" />
                            <ActionItem :workflow="workflow" :item="item" v-if="item.type === 'action'" />
                            <DelayItem  :workflow="workflow" :item="item" v-if="item.type === 'delay'" />
                            <FilterItem :workflow="workflow" :item="item" v-if="item.type === 'filter'" />

                            <!--<p><small>{{ item }}</small></p>
                            <p><small>{{ workflow }}</small></p>-->

                            <div class="opui-form-actions opui-justify-content-between opui-flex" v-if="item.type">
                                <button type="button" class="opui-btn opui-btn-outline-secondary opui-px-6" @click.prevent="closeAllModals">{{ $e('Cancel') }}</button>

                                <button type="submit" class="opui-btn opui-btn-primary" :class="{ saving: saving, disabled: saving || ! canBeSaved }" :disabled="saving || ! canBeSaved">
                                    <span class="opui-spinner opui-spinner-border opui-text-light opui-mr-2"></span>
                                    <span class="opui-btn-saving-label">{{ $e('Saving...') }}</span>
                                    <span class="opui-btn-label">{{ $e('Save') }}</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </vue-final-modal>
</template>

<script>
import ActionItem from "./ActionItem.vue"
import AddToMembership from "../Actions/AddToMembership.vue"
import DelayItem from "./DelayItem.vue"
import FilterItem from "./FilterItem.vue"
import ItemType from "./ItemType.vue"
import OptinForm from "../Actions/OptinForm.vue"
import WebhookForm from "../Actions/WebhookForm.vue"
import RichSelect from "../../Global/RichSelect.vue"

export default {
    components: { ActionItem, AddToMembership, DelayItem, FilterItem, ItemType, RichSelect, OptinForm, WebhookForm },
    props: {
        workflow:  { type: Object, required: true },
        item:      { type: Object, required: true },
        afterOrder: null,
    },
    data() {
        return {
            saving: false
        }
    },
    computed: {
        orderId() {
            if (this.afterOrder === 0) {
                return 5
            }

            return this.afterOrder ? parseInt(this.afterOrder) + 5 : (this.workflow.items.length * 10) + 10
        },

        canBeSaved() {
            if (this.item.type === 'delay') {
                return !! this.item.settings.value && !! this.item.settings.unit
            } else if (! this.item.validated) {
                return false
            } else {
                return !! this.item.action
            }
        },
    },
    methods: {
        /**
         * Add new action item
         */
        async save() {
            // Check item validation
            if (! this.item.validated && this.item.type !== 'delay') {
                this.$toast.error("Please enter all required data")
            } else {
                // Check if we're updating an existing item
                if (this.item.id) {
                    this.$events.emit('itemUpdated', this.item)
                    this.$emit('updated')
                } else {
                    // Create a new action object
                    let item = {
                        id:          'new.'+Math.floor(Date.now() / 1000),
                        workflow_id: this.workflow.id,
                        title:       this.item.title,
                        description: this.item.description,
                        action:      this.item.action,
                        settings:    this.item.settings,
                        type:        this.item.type,
                        order_id:    this.orderId
                    }

                    // Update the workflow
                    if (! this.workflow.items) {
                        this.workflow.items = []
                    }
                    this.workflow.items.push(item)
                    this.$events.emit('itemAdded', item)
                    this.$emit('updated')

                    // And reset action
                    this.item.action = null
                }
            }

            this.closeAllModals()
        },
    }
}
</script>

<style scoped>
.opui-modal-backdrop {
    opacity: .5;
}
</style>
